module.exports = __webpack_public_path__ + "img/logo-white.2c188522.svg";